const SUPPORTED_LANGUAGES = ['en', 'sv'];

export const languageConstants = {
  SUPPORTED_LANGUAGES,
};
